import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailquoteService {

  private quotePath = 'emailquote';

  constructor(private httpService: HttpService) {
  }

  sendQuote(body): Observable<any> {
    return this.httpService.httpPost(this.quotePath, body).pipe(response => {
      return response;
    });
  }
}
